import React from 'react'
import { useState } from 'react';
import placeholder from '../assets/image_placeholder.jpg'

const IconGeneration = () => {
    const [text, setText] = useState("")
    const [image, setImage] = useState(placeholder)
    const [loading, setLoading] = useState(false)
    async function query(data) {
        
        const response = await fetch(
            "https://api-inference.huggingface.co/models/black-forest-labs/FLUX.1-dev",
            {
                headers: {
                    Authorization: process.env.REACT_APP_FLUX_TOKEN,
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify(data),
            }
        );
        const result = await response.blob();
        var objectURL = URL.createObjectURL(result);
        setImage(objectURL)
        


        return result;
    }
    const generateImage = (input) => {
        setLoading(true)
        query({"inputs": input}).then((response) => {
            setLoading(false)
        });

    }
    
  return (
    <div className='font-main flex justify-center items'>
        <div className='bg-black text-white rounded-3xl p-8 w-3/4'>
        <h1 className='text-white text-center text-8xl'>Icon Generation (beta)</h1>
<input 
  className="text-4xl w-4/5 border-white rounded-lg text-black p-4 m-4" 
  onChange={(e) => 
    setText(`An image with a white background that has the clipart image of ${e.target.value} big and centered.`)
  }
/>
        <button className="text-4xl bg-white p-4 px-8 rounded-full text-black" onClick={() => generateImage(text)}>Submit</button>
       {loading && <div className='text-4xl text-center'>Loading your icon. Please standby <svg class="animate-spin h-5 w-5 text-white mr-3 ..." viewBox="0 0 24 24">
   ...
  </svg></div>} 
        <div className='text-4xl'>Image Output:
            <div className='flex justify-center'>
            <img className="h-96 " height={50} src={image}/>

            </div>
            
        </div>
    </div>

    </div>
    
  )
}

export default IconGeneration;
